export const darkTheme = {
  bg: '#0D120E',
  card: '#1A1F1B',
  text: '#ffffff',
  subtext: '#A1ACAB',
  accent: '#DFFF00',
  sidebarAccent: '#6E7F6B',
  surfaceMuted: '#222924',
  success: '#7AD69A',
  danger: '#FF8A8A'
}

export const lightTheme = {
  bg: '#F0F0EC',
  card: '#FFFFFF',
  text: '#1A1F1B',
  subtext: '#636E72',
  accent: '#5a8040',
  sidebarAccent: '#6E7F6B',
  surfaceMuted: '#E8EDE7',
  success: '#2E7D32',
  danger: '#C62828'
}
